import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useMakesStore from 'Stores/MakesStore/MakesStore';
import useModelsStore from 'Stores/ModelsStore/ModelsStore';

import { useInsightsStore } from './InsightsStore';

const InsightsStoreUrlSynchronizer: FC<PropsWithChildren> = ({ children }) => {
	const router = useRouter();

	const { setMakeAndModel } = useInsightsStore((state) => state);

	const {
		query: { make, model },
	} = router;

	const allMakes = useMakesStore((state) => state.makes);
	const allModels = useModelsStore((state) => state.models);

	useEffect(() => {
		if (!setMakeAndModel) {
			return;
		}

		const handleRouteChange = () => {
			setMakeAndModel(String(make), String(model), allMakes, allModels);
		};

		router.events.on('routeChangeComplete', handleRouteChange);

		// eslint-disable-next-line consistent-return
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router, allMakes, allModels, make, model, setMakeAndModel]);

	return <>{children}</>;
};

export default InsightsStoreUrlSynchronizer;
